export const TITLE = 'Oppss... :('

/**
 * Nombre accesible del h1 cuando se muestra `TITLE`: «Oppss... :(» es el tono
 * del diseño, pero como encabezado no dice qué ha pasado (WCAG 2.4.6). Se lee
 * esto en su lugar; lo visible no cambia.
 */
export function buildAccessibleHeading(code: number | string): string {
  if (Number(code) === 404) return 'Página no encontrada'
  if (Number(code) === 403) return 'Acceso denegado'
  return 'La página no responde'
}

export const DEFAULT_CODE = 404

/**
 * Código mostrado cuando el error no trae un `status` HTTP real que reflejar
 * (`resolveErrorPageOutcome`: timeout/red/JSON inválido) o cuando no hay
 * ningún error concreto del que leerlo en absoluto (el error boundary de
 * `(general-web)/error.tsx`, que por ser Client Component no recibe las
 * propiedades custom del error de servidor).
 */
export const GENERIC_SERVER_ERROR_CODE = 500

export const HOME_LINK_LABEL = 'Ir a página de inicio'

/**
 * `{code}` se sustituye por el código HTTP real de la respuesta de error
 * (FR — "el código del error debe poder variar según lo que llegue"), en vez
 * de dejarlo fijo a "404" como en el texto de referencia de Figma.
 */
export function buildDescription(code: number | string): string {
  return `Lo sentimos. La página que estás buscando no existe o no responde en este momento. Esto se conoce en argot informático como error ${code}, pero no te preocupes.`
}

/** `id` sintético del módulo de recuperación — `meta.modules` no lo trae (no
 * es un módulo real de `page.modules`), pero algún componente del catálogo
 * (p. ej. `ProductosLocalizados`) lo usa para construir ids de accesibilidad. */
export const FALLBACK_MODULE_ID = 'error-fallback-module'

/**
 * `<title>` de cualquier página que termine mostrando `ErrorPageFallback`
 * (petición 2026-09-11) — mismo `code` que ve el usuario en pantalla
 * (`buildDescription`), para no mostrar un título de éxito en una página de
 * error. Sufijo de marca distinto del resto del sitio (`resolveCmsPageTitle`
 * usa "Entradas El Corte Inglés"): aquí, deliberadamente, solo "El Corte
 * Inglés".
 */
export function buildErrorPageTitle(code: number | string = DEFAULT_CODE): string {
  return `Página no encontrada - ${code} | El Corte Inglés`
}
